import React from 'react';
import { Box } from '@mui/material';
import { actionButtonSizingSx } from './buttonSizing';

interface ModalActionGroupProps {
  children: React.ReactNode;
  gap?: number;
  minWidth?: number;
  fullWidth?: boolean;
  layout?: 'auto' | 'stack' | 'row';
}

const ModalActionGroup: React.FC<ModalActionGroupProps> = ({
  children,
  gap = 1,
  minWidth = 0,
  fullWidth = false,
  layout = 'auto',
}) => {
  const actions = React.Children.toArray(children);
  const stacked = layout === 'stack';
  return (
    <Box
      className="fable-modal-actions"
      sx={{
        display: 'flex',
        flexDirection: stacked ? 'column' : 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        width: fullWidth ? '100%' : 'fit-content',
        gap,
        maxWidth: '100%',
        ml: 'auto',
        mr: 0,
        '& > .MuiButton-root': {
          ...actionButtonSizingSx,
          width: fullWidth && stacked ? '100%' : 'auto',
          flex: fullWidth && !stacked ? '1 1 0' : '0 1 auto',
          minWidth: `min(100%, ${minWidth}px)`,
          maxWidth: '100%',
          ml: '0 !important',
          whiteSpace: 'normal',
          overflowWrap: 'anywhere',
        },
      }}
    >
      {actions}
    </Box>
  );
};

export default ModalActionGroup;
